import { cn } from '@/app/utils';

interface LoaderProps {
  className?: string;
}

export function Loader({ className }: LoaderProps) {
  return (
    <div
      style={
        {
          '--_g': 'no-repeat radial-gradient(circle closest-side,#ccc 90%,#0000)',
          background: 'var(--_g) 0%   50%,var(--_g) 50%  50%,var(--_g) 100% 50%',
          backgroundSize: 'calc(100%/3) 50%',
        } as React.CSSProperties
      }
      className={cn('aspect-[2] w-[60px] animate-global-loading', className)}
    />
  );
}
